import { getCmsBaseUri } from '@n2-common/lib/serverSideConfigs';
import { CmsNotification } from './cmsNotification';
import { default as fetch } from '@n2-common/lib/fetchProxy';
import { CmsMyPageContent } from './mypageContent';

export async function getNotifications(key: string, signal?: AbortSignal): Promise<CmsNotification[]> {
    const requestPath = `/api/notifications?key=${key}`;
    try {
        const cmsBaseUri = getCmsBaseUri();
        const response = await fetch(cmsBaseUri + requestPath, { method: 'GET', redirect: 'error', signal });
        const notifications = (await response.json()) as CmsNotification[];
        return notifications;
    } catch (err) {
        return [] as CmsNotification[];
    }
}

export async function getMyPageContent(
    key: string,
    country: Country,
    hasLoan: boolean,
    hasCreditCard: boolean,
    hasSavings: boolean,
    signal?: AbortSignal
): Promise<CmsMyPageContent> {
    const requestPath = `/api/mypage-content/${key}?country=${country}&hasLoan=${hasLoan}&hasCreditCard=${hasCreditCard}&hasSavings=${hasSavings}`;
    try {
        const cmsBaseUri = getCmsBaseUri();
        const response = await fetch(cmsBaseUri + requestPath, { method: 'GET', redirect: 'error', signal });
        if (!response.ok) {
            throw new Error(`Failed to get my page content for key: ${key}`);
        }
        const notifications = (await response.json()) as CmsMyPageContent;
        return notifications;
    } catch (err) {
        return Promise.reject(err);
    }
}
